import {dispatch, useSelector} from '../../store.js'
import ButtonAction from '../../common/components/Button/ButtonAction.js'
import {showCreatePOModal} from '../ProductListPage/Modals/CreatePOModal/createPOModalActions.js'
import AddProductTagsDropdown from '../ProductListPage/AddProductTagsDropdown.js'
import {showCreateInventoryTransferModal} from '../TransferListPage/Modals/CreateInventoryTransferModal/createInventoryTransferModalFunctions.js'
import {showBarcodeLabelModal} from '../ProductListPage/Modals/BarcodeLabelModal.js'
import {
  exportInventoryLog,
  isArchivedSelector,
  isKitSelector,
  isBOMSelector,
} from '../../data/products.js'
import {showFeatureLockedModal} from '../Modals/FeatureLockedModal.js'
import {showArchiveProductModal} from '../ProductListPage/Modals/ArchiveProductModal.js'
import {showSetupProductComponentModal} from '../ProductListPage/Modals/SetupProductComponentModal.js'
import {
  usesInventorySelector,
  canTransferInventorySelector,
  showFeatureLocksSelector,
  usePurchaseOrdersSelector,
  useKittingSelector,
} from '../../data/company.js'
import {skuSelector} from './productDetailSelectors.js'
import {hasMOFeatureSelector} from '../../data/mos.js'
import {
  hasMOPermissionSelector,
  hasTransferPermissionSelector,
} from '../../data/me.js'
import {showCreateMOModal} from '../MOListPage/Modals/CreateMOModal.js'
import {showEditReportModal} from '../ReportsPage/Modals/EditReportModal.js'
import {REPORT_EXPORT_INVENTORY_EVENTS} from '../../common/constants/Reports.js'
import Icon from '../../common/icons/Icon.js'
import {reportOptionsByValueSelector} from '../ReportsPage/reportsPageSelectors.js'

export default function Controls() {
  const sku = useSelector(skuSelector)
  const isArchived = useSelector((state) => isArchivedSelector(state, {sku}))
  const canTransferInventory = useSelector(canTransferInventorySelector)
  const usesInventory = useSelector(usesInventorySelector)
  const useKitting = useSelector(useKittingSelector)
  const usePurchaseOrders = useSelector(usePurchaseOrdersSelector)
  const showFeatureLocks = useSelector(showFeatureLocksSelector)
  const hasMOFeature = useSelector(hasMOFeatureSelector)
  const hasMOPermission = useSelector(hasMOPermissionSelector)
  const hasTransferPermission = useSelector(hasTransferPermissionSelector)
  const isKit = useSelector((state) => isKitSelector(state, {sku}))
  const isBOM = useSelector((state) => isBOMSelector(state, {sku}))
  const canConvert = hasMOFeature || useKitting
  const reportOptionsByValue = useSelector(reportOptionsByValueSelector)

  return (
    <div className="wrap--row">
      <div className="medium-12 columns">
        <div className="wrap--list-header flex--justify">
          <ul className="list list--no-style">
            <li className="inline-block v-align-base divider--right">
              <a
                href="#/products"
                className="btn btn--action"
                title="Back to products"
              >
                &#8592; Products
              </a>
            </li>
            {(showFeatureLocks || usePurchaseOrders) && (
              <li className="inline-block fs-n0 margin-right-5">
                {!usePurchaseOrders && (
                  <Icon
                    name="lock-closed"
                    className="fs-01 v-align-middle lh-lg no-underline op-30 margin-right-1"
                  />
                )}
                <ButtonAction
                  className={`${usePurchaseOrders ? '' : 'op-50'}`}
                  onClick={() =>
                    usePurchaseOrders
                      ? showCreatePOModal([sku])
                      : showFeatureLockedModal('po')
                  }
                >
                  Order More
                </ButtonAction>
              </li>
            )}
            {hasMOPermission && isBOM && (showFeatureLocks || hasMOFeature) && (
              <li className="inline-block fs-n0 margin-left-15 margin-right-5">
                {!hasMOFeature && (
                  <Icon
                    name="lock-closed"
                    className="fs-01 v-align-middle lh-lg no-underline op-30 margin-right-1"
                  />
                )}
                <ButtonAction
                  className={`${hasMOFeature ? '' : 'op-50'}`}
                  onClick={() =>
                    hasMOFeature
                      ? showCreateMOModal({skus: [sku]})
                      : showFeatureLockedModal('mo')
                  }
                >
                  Initiate a MFG Order
                </ButtonAction>
              </li>
            )}
            <AddProductTagsDropdown skus={[sku]} />
            {hasTransferPermission &&
              (showFeatureLocks || canTransferInventory) && (
                <li className="inline-block fs-n0 margin-left-15 margin-right-5">
                  {!canTransferInventory && (
                    <Icon
                      name="lock-closed"
                      className="fs-01 v-align-middle lh-lg no-underline op-30 margin-right-1"
                    />
                  )}
                  <ButtonAction
                    className={`${canTransferInventory ? '' : 'op-50'}`}
                    onClick={() =>
                      canTransferInventory
                        ? showCreateInventoryTransferModal([sku])
                        : showFeatureLockedModal('inventory')
                    }
                  >
                    Transfer Inventory
                  </ButtonAction>
                </li>
              )}
            <li className="inline-block fs-n0 margin-left-15 margin-right-5">
              <ButtonAction onClick={() => showBarcodeLabelModal([sku])}>
                Print Barcodes
              </ButtonAction>
            </li>
            {(showFeatureLocks || usesInventory) && (
              <li className="inline-block fs-n0 margin-left-15 margin-right-5">
                {!usesInventory && (
                  <Icon
                    name="lock-closed"
                    className="fs-01 lh-lg no-underline op-30 margin-right-1"
                  />
                )}
                <ButtonAction
                  className={`${usesInventory ? '' : 'op-50'}`}
                  onClick={() =>
                    usesInventory
                      ? exportInventoryLog(sku)
                      : showFeatureLockedModal('inventory')
                  }
                >
                  Export Inventory Log
                </ButtonAction>
              </li>
            )}
            {reportOptionsByValue[REPORT_EXPORT_INVENTORY_EVENTS] && (
              <li className="inline-block fs-n0 margin-left-15 margin-right-5">
                <ButtonAction
                  onClick={() =>
                    showEditReportModal({
                      reportType: REPORT_EXPORT_INVENTORY_EVENTS,
                      singleRun: true,
                      sku,
                    })
                  }
                >
                  {reportOptionsByValue[REPORT_EXPORT_INVENTORY_EVENTS].display}
                </ButtonAction>
              </li>
            )}
            {(showFeatureLocks || canConvert) && !isKit && !isBOM && (
              <li className="inline-block fs-n0 margin-left-15 margin-right-5">
                {!canConvert && (
                  <Icon
                    name="lock-closed"
                    className="fs-01 v-align-middle lh-lg no-underline op-30 margin-right-1"
                  />
                )}
                <ButtonAction
                  className={`${canConvert ? '' : 'op-50'}`}
                  onClick={() =>
                    canConvert
                      ? showSetupProductComponentModal(sku)
                      : showFeatureLockedModal('mo')
                  }
                >
                  Convert to{' '}
                  {[useKitting ? 'Kit' : '', hasMOFeature ? 'BOM' : '']
                    .filter((v) => v)
                    .join('/')}
                </ButtonAction>
              </li>
            )}
            <li className="inline-block fs-n0 margin-left-15 margin-right-5">
              <ButtonAction
                onClick={() =>
                  dispatch(showArchiveProductModal([sku], !isArchived))
                }
              >
                {isArchived ? 'Unarchive' : 'Archive'}
              </ButtonAction>
            </li>
          </ul>
        </div>
        <hr className="hr--detail-page margin-top-3" />
      </div>
    </div>
  )
}
